import styled from "styled-components";

export const Wrapper = styled.div<{ displayPipe?: boolean }>`
  width: 295px;
  position: relative;
  left: ${({ displayPipe }) => (displayPipe === true ? -6 : -100)}px;
  display: flex;
  align-items: center;
`;

export const CheckboxSection = styled.div`
  display: inline-flex;
  margin-right: 5px;
  cursor: pointer;
  position: relative;
`;

export const CheckboxText = styled.div`
  margin: 0 7px 0 2px;
  display: inline-flex;
  position: relative;
  cursor: pointer;
  font-weight: 700;
  font-size: 9px;
  line-height: 11px;
  color: #878b92;
`;

export const VerticalLine = styled.div`
  display: inline-flex;
  margin: 0px 5px 0 10px;
  border-left: 1px solid #c7c8c9;
  height: 16px;
`;
